import styled, { css, FlattenInterpolation, FlattenSimpleInterpolation, keyframes, ThemeProps, ThemeProvider } from "styled-components";

export type { FlattenInterpolation, FlattenSimpleInterpolation, ThemeProps };
export { css, keyframes, ThemeProvider };
export default styled;
